import { Component, OnInit } from '@angular/core';
import { TemplateUpdateService } from '../../../services/template-update.service';
@Component({
  selector: 'tool-tip-accessibility',
  templateUrl: './tool-tip-accessibility.component.html',
  styleUrls: ['./tool-tip-accessibility.component.sass']
})
export class ToolTipAccessibilityComponent implements OnInit {
  infoText = this.templateService.accessibilityInfoText;
  header = this.templateService.accessibilityHeader;

  constructor(private templateService: TemplateUpdateService) { }

  ngOnInit(): void {
  }

}
